// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgCallUnanswered24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M7.46828 16.5323C7.17539 16.2394 7.17539 15.7645 7.46828 15.4716L10.9396 12.0003L7.46783 8.52907C7.17492 8.2362 7.17488 7.76133 7.46776 7.46841C7.76063 7.1755 8.2355 7.17546 8.52842 7.46834L12.0003 10.9397L15.4716 7.46846C15.7645 7.17557 16.2394 7.17559 16.5323 7.46849C16.8252 7.76139 16.8252 8.23626 16.5323 8.52915L13.061 12.0003L16.5323 15.4716C16.8252 15.7645 16.8252 16.2394 16.5323 16.5323C16.2394 16.8252 15.7645 16.8252 15.4716 16.5323L12.0003 13.0609L8.52894 16.5323C8.23605 16.8252 7.76118 16.8252 7.46828 16.5323Z"
				/>
			</Svg>
		);
	}
);
SvgCallUnanswered24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgCallUnanswered24;
